"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateTenantStripCard = exports.getTenantPreviewInvoice = exports.getTenantUpcomingInvoice = exports.getTenantInvoices = exports.getTenantCard = exports.updateTenantUserRequest = exports.updateTenantUser = exports.removeUserFromTenant = exports.addTenantUsers = exports.getTenantUser = exports.getTenantUsers = exports.addTenantUserRequest = exports.getTenantUserRequests = exports.updateTenant = exports.getUpdateTenantSuccessMessage = exports.requestTenant = exports.addTenant = exports.requestTenants = exports.closeEditTenantUserModal = exports.showEditTenantUserModal = exports.closeAddTenantUsersModal = exports.showAddTenantUsersModal = exports.closeAddTenantModal = exports.showAddTenantModal = void 0;

var _apiServices = require("@pingum/api-services");

var types = _interopRequireWildcard(require("./types"));

var _networkDispatcher = require("../networkDispatcher");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var showAddTenantModal = function showAddTenantModal() {
  return {
    type: types.SHOW_ADD_TENANT_MODAL
  };
};

exports.showAddTenantModal = showAddTenantModal;

var closeAddTenantModal = function closeAddTenantModal() {
  return {
    type: types.CLOSE_ADD_TENANT_MODAL
  };
};

exports.closeAddTenantModal = closeAddTenantModal;

var showAddTenantUsersModal = function showAddTenantUsersModal() {
  return {
    type: types.SHOW_ADD_TENANT_USERS_MODAL
  };
};

exports.showAddTenantUsersModal = showAddTenantUsersModal;

var closeAddTenantUsersModal = function closeAddTenantUsersModal() {
  return {
    type: types.CLOSE_ADD_TENANT_USERS_MODAL
  };
};

exports.closeAddTenantUsersModal = closeAddTenantUsersModal;

var showEditTenantUserModal = function showEditTenantUserModal() {
  return {
    type: types.SHOW_EDIT_TENANT_USER_MODAL
  };
};

exports.showEditTenantUserModal = showEditTenantUserModal;

var closeEditTenantUserModal = function closeEditTenantUserModal() {
  return {
    type: types.CLOSE_EDIT_TENANT_USER_MODAL
  };
};

exports.closeEditTenantUserModal = closeEditTenantUserModal;

var requestTenants = function requestTenants() {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.TENANTS_REQUESTED,
      successType: types.TENANTS_SUCCESS,
      errorType: types.TENANTS_ERROR,
      promise: _apiServices.TenantService.getTenants(),
      defaultErrorMessage: 'There was a problem loading organizations',
      responseName: 'tenants'
    });
  };
};

exports.requestTenants = requestTenants;

var addTenant = function addTenant(newTenant) {
  return function (dispatch) {
    var promise = _apiServices.TenantService.addTenant(newTenant);

    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.TENANT_ADD_REQUESTED,
      successType: types.TENANT_ADD_SUCCESS,
      errorType: types.TENANT_ADD_ERROR,
      promise: promise,
      defaultErrorMessage: 'There was a problem creating the organization',
      responseName: 'tenant'
    });
    return promise;
  };
};

exports.addTenant = addTenant;

var requestTenant = function requestTenant(name) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.TENANT_GET_REQUESTED,
      successType: types.TENANT_GET_SUCCESS,
      errorType: types.TENANT_GET_ERROR,
      promise: _apiServices.TenantService.getTenant(name),
      defaultErrorMessage: 'There was a problem loading the organization',
      responseName: 'tenant'
    });
  };
};

exports.requestTenant = requestTenant;

var getUpdateTenantSuccessMessage = function getUpdateTenantSuccessMessage(updateTenantRequest) {
  var message = 'Successfully updated organization information';

  if (updateTenantRequest.newPaymentPlan) {
    message = 'Successfully subscribed to new plan';
  } else if (updateTenantRequest.stripeAddCardToken) {
    message = 'Successfully added new payment method - now validating card...';
  }

  return message;
};

exports.getUpdateTenantSuccessMessage = getUpdateTenantSuccessMessage;

var updateTenant = function updateTenant(updatedTenant) {
  return function (dispatch) {
    var promise = _apiServices.TenantService.updateTenant(updatedTenant);

    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.TENANT_UPDATE_REQUESTED,
      successType: types.TENANT_UPDATE_SUCCESS,
      errorType: types.TENANT_UPDATE_ERROR,
      promise: promise,
      successMessage: getUpdateTenantSuccessMessage(updatedTenant),
      defaultErrorMessage: 'There was a problem updating the organization',
      responseName: 'tenant'
    });
    return promise;
  };
};

exports.updateTenant = updateTenant;

var getTenantUserRequests = function getTenantUserRequests(name) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.TENANT_USER_REQUESTS_REQUESTED,
      successType: types.TENANT_USER_REQUESTS_SUCCESS,
      errorType: types.TENANT_USER_REQUESTS_ERROR,
      promise: _apiServices.TenantService.getTenantUserRequests(name),
      defaultErrorMessage: 'There was a problem loading user requests',
      responseName: 'tenantUserRequests'
    });
  };
};

exports.getTenantUserRequests = getTenantUserRequests;

var addTenantUserRequest = function addTenantUserRequest(name, newTenantUserRequest) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.TENANT_USER_REQUEST_ADD_REQUESTED,
      successType: types.TENANT_USER_REQUEST_ADD_SUCCESS,
      errorType: types.TENANT_USER_REQUEST_ADD_ERROR,
      promise: _apiServices.TenantService.addTenantUserRequest(name, newTenantUserRequest),
      successMessage: 'The request to join the organization has been sent. You can only send this request once',
      defaultErrorMessage: 'There was a problem adding the request to join',
      responseName: 'tenantUserRequest'
    });
  };
};

exports.addTenantUserRequest = addTenantUserRequest;

var getTenantUsers = function getTenantUsers(name) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.TENANT_USERS_REQUESTED,
      successType: types.TENANT_USERS_SUCCESS,
      errorType: types.TENANT_USERS_ERROR,
      promise: _apiServices.TenantService.getTenantUsers(name),
      defaultErrorMessage: 'There was a problem loading organization users',
      responseName: 'tenantUsers'
    });
  };
};

exports.getTenantUsers = getTenantUsers;

var getTenantUser = function getTenantUser(name, auth0UserId) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.TENANT_USER_REQUESTED,
      successType: types.TENANT_USER_SUCCESS,
      errorType: types.TENANT_USER_ERROR,
      promise: _apiServices.TenantService.getTenantUser(name, auth0UserId),
      defaultErrorMessage: 'There was a problem loading the organization user',
      responseName: 'tenantUser'
    });
  };
};

exports.getTenantUser = getTenantUser;

var addTenantUsers = function addTenantUsers(name, newTenantUsers) {
  return function (dispatch) {
    var promise = _apiServices.TenantService.addTenantUsers(name, newTenantUsers);

    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.TENANT_USERS_ADD_REQUESTED,
      successType: types.TENANT_USERS_ADD_SUCCESS,
      errorType: types.TENANT_USERS_ADD_ERROR,
      promise: promise,
      successMessage: 'Successfully added users to the organization',
      defaultErrorMessage: 'There was a problem adding the organization users',
      responseName: 'tenantUsers'
    });
    return promise;
  };
};

exports.addTenantUsers = addTenantUsers;

var removeUserFromTenant = function removeUserFromTenant(name, auth0UserId) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequestDynamicSuccessDispatch)({
      dispatch: dispatch,
      requestType: types.TENANT_USER_REMOVE_REQUESTED,
      successDispatch: {
        type: types.TENANT_USER_REMOVE_SUCCESS,
        auth0UserId: auth0UserId
      },
      errorType: types.TENANT_USER_REMOVE_ERROR,
      promise: _apiServices.TenantService.removeUserFromTenant(name, auth0UserId),
      successMessage: 'Successfully removed the user from the organization',
      defaultErrorMessage: 'There was a problem removing this user from the organization',
      responseName: 'removeUserReponse'
    });
  };
};

exports.removeUserFromTenant = removeUserFromTenant;

var updateTenantUser = function updateTenantUser(name, auth0UserId, updateTenantUserRequest) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequestDynamicSuccessDispatch)({
      dispatch: dispatch,
      requestType: types.TENANT_USER_UPDATE_REQUESTED,
      successDispatch: {
        type: types.TENANT_USER_UPDATE_SUCCESS,
        auth0UserId: auth0UserId
      },
      errorType: types.TENANT_USER_UPDATE_ERROR,
      promise: _apiServices.TenantService.updateTenantUser(name, auth0UserId, updateTenantUserRequest),
      successMessage: 'Successfully updated the user',
      defaultErrorMessage: 'There was a problem updating this user for the organization',
      responseName: 'tenantUser'
    });
  };
};

exports.updateTenantUser = updateTenantUser;

var updateTenantUserRequest = function updateTenantUserRequest(tenantUserRequestId, accepted) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequestDynamicSuccessDispatch)({
      dispatch: dispatch,
      requestType: types.TENANT_USER_REQUEST_UPDATE_REQUESTED,
      successDispatch: {
        type: types.TENANT_USER_REQUEST_UPDATE_SUCCESS,
        tenantUserRequestId: tenantUserRequestId
      },
      errorType: types.TENANT_USER_REQUEST_UPDATE_ERROR,
      promise: _apiServices.TenantUserRequestService.updateTenantUserRequest(tenantUserRequestId, accepted),
      successMessage: "The request has been ".concat(accepted ? 'accepted' : 'declined'),
      defaultErrorMessage: 'There was a problem updating the user request to join the organization',
      responseName: 'response'
    });
  };
};

exports.updateTenantUserRequest = updateTenantUserRequest;

var getTenantCard = function getTenantCard(name, cardId) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.TENANT_STRIPE_CARD_REQUESTED,
      successType: types.TENANT_STRIPE_CARD_SUCCESS,
      errorType: types.TENANT_STRIPE_CARD_ERROR,
      promise: _apiServices.TenantService.getTenantCard(name, cardId),
      defaultErrorMessage: 'There was a plroblem loading the payment information',
      responseName: 'stripeCard'
    });
  };
};

exports.getTenantCard = getTenantCard;

var getTenantInvoices = function getTenantInvoices(name) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.TENANT_STRIPE_INVOICES_REQUESTED,
      successType: types.TENANT_STRIPE_INVOICES_SUCCESS,
      errorType: types.TENANT_STRIPE_INVOICES_ERROR,
      promise: _apiServices.TenantService.getTenantInvoices(name),
      defaultErrorMessage: 'There was a problem loading past invoices',
      responseName: 'stripeInvoices'
    });
  };
};

exports.getTenantInvoices = getTenantInvoices;

var getTenantUpcomingInvoice = function getTenantUpcomingInvoice(name) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.TENANT_STRIPE_UPCOMING_INVOICES_REQUESTED,
      successType: types.TENANT_STRIPE_UPCOMING_INVOICES_SUCCESS,
      errorType: types.TENANT_STRIPE_UPCOMING_INVOICES_ERROR,
      promise: _apiServices.TenantService.getTenantUpcomingInvoice(name),
      defaultErrorMessage: 'There was a problem loading the upcoming invoice',
      responseName: 'stripeUpcomingInvoice'
    });
  };
};

exports.getTenantUpcomingInvoice = getTenantUpcomingInvoice;

var getTenantPreviewInvoice = function getTenantPreviewInvoice(name, newStripePlan, newUserLimit) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.TENANT_STRIPE_PREVIEW_INVOICE_REQUESTED,
      successType: types.TENANT_STRIPE_PREVIEW_INVOICE_SUCCESS,
      errorType: types.TENANT_STRIPE_PREVIEW_INVOICE_ERROR,
      promise: _apiServices.TenantService.getTenantPreviewInvoice(name, newStripePlan, newUserLimit),
      defaultErrorMessage: 'There was a problem loading the invoice preview',
      responseName: 'stripePreviewInvoice'
    });
  };
};

exports.getTenantPreviewInvoice = getTenantPreviewInvoice;

var updateTenantStripCard = function updateTenantStripCard(stripeCard) {
  return {
    type: types.TENANT_STRIPE_UPDATE_CARD,
    stripeCard: stripeCard
  };
};

exports.updateTenantStripCard = updateTenantStripCard;